import { useEffect, useRef, useState } from "react";
import axios from "axios";
import useTranslator from "../../hooks/useTranslator";
import SkorLogo from "../../assets/img/skorLogo.svg";
import Flag from "../../assets/img/flag.svg";
import "../skor-protect/SkorProtectPayment.css";
import "./GuarantorInvitation.css";

const STATUS = {
  VALIDATING: "validating",
  REDIRECTING: "redirecting",
  ERROR: "error",
};

const SpinnerIcon = () => (
  <div className="skp-spinner-wrap">
    <svg
      className="skp-spinner"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <circle cx="21" cy="21" r="17" stroke="#e8eceb" strokeWidth="4" />
      <path
        d="M38 21a17 17 0 0 0-17-17"
        stroke="#253837"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

const ErrorIcon = () => (
  <div className="skp-status-icon error">
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
      <path
        d="M11 11l12 12M23 11 11 23"
        stroke="#253837"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

const GuarantorInvitation = () => {
  const { _t, i18n } = useTranslator();
  const requestStarted = useRef(false);
  const [status, setStatus] = useState(STATUS.VALIDATING);
  const [lang, setLang] = useState(
    i18n.language?.startsWith("en") ? "en-us" : "es"
  );

  const changeLanguage = async (language) => {
    await i18n.changeLanguage(language);
    localStorage.setItem("i18nextLng", language);
    setLang(language);
  };

  useEffect(() => {
    if (requestStarted.current) return;
    requestStarted.current = true;

    const params = new URLSearchParams(window.location.search);
    const invitationToken = params.get("token");

    window.history.replaceState({}, "", window.location.pathname);

    if (!invitationToken) {
      setStatus(STATUS.ERROR);
      return;
    }

    const validateInvitation = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/guarantor-invitations/${encodeURIComponent(
            invitationToken
          )}`,
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng") || "en",
            },
          }
        );
        const redirectUrl = response.data?.success_res?.redirectUrl;

        if (!redirectUrl) {
          setStatus(STATUS.ERROR);
          return;
        }

        setStatus(STATUS.REDIRECTING);
        window.location.replace(redirectUrl);
      } catch {
        setStatus(STATUS.ERROR);
      }
    };

    validateInvitation();
  }, []);

  return (
    <div className="skp-page">
      <div className="skp-card guarantor-invitation-card">
        <div className="guarantor-invitation-language">
          {lang === "es" ? (
            <button type="button" onClick={() => changeLanguage("en-us")}>
              <img src="/images/spain-flag.png" alt="Español" />
              <span>ES</span>
            </button>
          ) : (
            <button type="button" onClick={() => changeLanguage("es")}>
              <img src={Flag} alt="English" />
              <span>EN</span>
            </button>
          )}
        </div>

        <img className="skp-logo" src={SkorLogo} alt="Skor" />

        {status === STATUS.ERROR ? <ErrorIcon /> : <SpinnerIcon />}

        <h2 className="skp-title">
          {status === STATUS.VALIDATING && _t("pleaseWait")}
          {status === STATUS.REDIRECTING && _t("redirecting")}
          {status === STATUS.ERROR && _t("unableToProcessRequest")}
        </h2>

        <p
          className={`skp-text ${status === STATUS.ERROR ? "skp-error-text" : ""}`}
        >
          {status === STATUS.VALIDATING && _t("pleaseWait")}
          {status === STATUS.REDIRECTING && _t("redirecting")}
          {status === STATUS.ERROR && _t("invitationLinkIsInvalid")}
        </p>

        {status === STATUS.ERROR && (
          <button
            type="button"
            className="skp-btn"
            onClick={() => window.location.replace("/")}
          >
            {_t("goToHome")}
          </button>
        )}
      </div>
    </div>
  );
};

export default GuarantorInvitation;
